import IntegrationProductsTable from './IntegrationProductsTable.jsx';
import NoProducts from './NoProducts.jsx';
import { useAuthContext } from '../../../../contexts/AuthContext.jsx';
import { getIntegrationProductsV2 as getIntegrationProducts } from '../../../../libs/fetch.js';
import { useState, useEffect } from 'react';

function TableSkeleton() {
  return (
    <div className="mt-6 space-y-4">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="animate-pulse flex space-x-4 p-4 border rounded bg-white shadow-sm">
          <div className="h-6 w-1/4 bg-gray-200 rounded" />
          <div className="h-6 w-1/2 bg-gray-100 rounded" />
          <div className="h-6 w-1/6 bg-gray-200 rounded" />
        </div>
      ))}
    </div>
  );
}

export default function IntegrationProductsGrid({ integrationId }) {
  const { currentOrganization, products } = useAuthContext();
  const [integrationProducts, setIntegrationProducts] = useState(null);
  const [loading, setLoading] = useState(true);

  const consumerProducts = products?.consumer_products;
  const shippers = products?.shippers;

  // Fetch integration products
  useEffect(() => {
    const fetchIntegrationProducts = async () => {
      setLoading(true);
      try {
        if (integrationId && currentOrganization) {
          const fetchedProducts = await getIntegrationProducts(currentOrganization, integrationId);
          setIntegrationProducts(fetchedProducts);
        } else {
          setIntegrationProducts(null);
        }
      } catch (err) {
        console.error("❌ Failed to fetch integration products:", err);
        setIntegrationProducts(null);
      } finally {
        setLoading(false);
      }
    };

    fetchIntegrationProducts();
  }, [currentOrganization, integrationId]);

  return (
    <div className="mt-6">
      {loading ? (
        <TableSkeleton />
      ) : integrationProducts ? (
        <IntegrationProductsTable 
          products={integrationProducts} 
          consumerProducts={consumerProducts} 
          shippers={shippers}
          currentOrganization={currentOrganization}
          integrationId={integrationId}
          onProductsUpdate={setIntegrationProducts}
        />
      ) : (
        <NoProducts />
      )}
    </div>
  );
}
